module.exports = __webpack_public_path__ + "img/caf50f5.jpg";